import { useTranslation } from 'react-i18next'

import {
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../../constants/common'
import { isValueNumberType } from '../../../../utils/common'
import { BUTTON_HEIGHT_32 } from '../../../Button'
import { EntityProfileNavigation } from '../../../Entity'
import { useProfileWidgetsHideContext } from '../../../Widget'
import { useEmailProfileContext } from '../../Email.hooks'
import { EmailProfileActionsWidgetNavigationRail } from '../EmailProfileActionsWidgetNavigationRail'

import * as styles from './EmailProfileActionsWidgetNavigation.module.css'

function EmailProfileActionsWidgetNavigation() {
  const { t } = useTranslation()

  const { navigation } = useEmailProfileContext()

  const { isWidgetsHidden } = useProfileWidgetsHideContext() ?? EMPTY_OBJECT

  const { handleNext, handlePrevious, hasNext, hasPrevious, index, total } =
    navigation

  function handleClickNext() {
    handleNext({ isWidgetsHidden })
  }

  function handleClickPrevious() {
    handlePrevious({ isWidgetsHidden })
  }

  return isWidgetsHidden ? (
    <EmailProfileActionsWidgetNavigationRail
      hasNext={hasNext}
      hasPrevious={hasPrevious}
      onNext={handleClickNext}
      onPrevious={handleClickPrevious}
    />
  ) : (
    <EntityProfileNavigation
      arrowsClassName={styles.arrows}
      counterText={
        isValueNumberType(index)
          ? t('EmailProfile.ActionsWidgetNavigationCounterKey', {
              current: index,
              total,
            })
          : null
      }
      hasNext={hasNext}
      hasPrevious={hasPrevious}
      nextTooltip={t('EmailProfile.ActionsWidgetNavigationNextTooltipKey')}
      previousTooltip={t('EmailProfile.ActionsWidgetNavigationPrevTooltipKey')}
      size={BUTTON_HEIGHT_32}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onNext={handleClickNext}
      onPrevious={handleClickPrevious}
    />
  )
}

export default EmailProfileActionsWidgetNavigation
